export default __webpack_public_path__ + "static/media/whitetail.8ce3ea2b.webp";